// extracted by mini-css-extract-plugin
export default {"list":"EventsList_list__cg852","events-list":"EventsList_events-list__jhjcc"};